<template>
  <div class="toggle pointer" @click="onClick" :class="{ active: active }">
    <div class="handle" :class="{ active: active }"></div>
  </div>
</template>

<script>
export default {
  props: ['active'],
  methods: {
    onClick() {
      this.$emit('action')
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle {
  border-radius: 20px;
  //border: 1px solid #979797;
  border: 1px solid var(--sub-color);
  height: 21px;
  padding: 2px;
  width: 34px;
  position: relative;

  /*  &.active{
    border-color: var(--sub-color);
  } */
}

.handle {
  background: #979797;
  border-radius: 15px;
  height: 15px;
  width: 15px;
  transition: all 0.2s;
  position: absolute;
  left: 2px;

  &.active {
    left: 15px;
    background-color: var(--sub-color);
  }
}
</style>
